<!--
* @description  注册组件
* @fileName  startedDialog
* @author userName
* @date 2023-12-21 17:53:23
!-->
<template>
  <div id="startedDialog" class="startedDialog">
    <global-login-dialog
      v-model="$store.getters.startedDialogVisible"
      @close="closeDialog"
    >
      <template v-slot:title>
        <div class="title-first">{{ $t('login.register') }}</div>
        <div class="title-two" />
      </template>
      <template v-slot:body>
        <div v-if="isShow">
          <el-form ref="loginForm1" :model="loginForm1" :rules="loginRules1">
            <el-form-item prop="email">
              <div class="left">{{ $t('login.email') }}</div>
              <el-input
                ref="email"
                v-model="loginForm1.email"
                :placeholder="$t('login.emailPlaceholder')"
                name="email"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="password">
              <div class="left">{{ $t('login.password') }}</div>
              <el-input
                ref="password"
                v-model="loginForm1.password"
                :placeholder="$t('login.passwordPlaceholder')"
                name="password"
                type="password"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
          </el-form>
          <button
            class="by-button--primary craetAccount"
            @click="createAccount()"
          >
            创建您的免费账户
          </button>
        </div>
        <div v-if="!isShow">
          <el-form ref="loginForm2" :model="loginForm2" :rules="loginRules2">
            <el-form-item prop="firstName">
              <div class="left">{{ $t('login.name') }}</div>
              <el-input
                ref="firstName"
                v-model="loginForm2.firstName"
                :placeholder="$t('login.namePlaceholder')"
                name="firstName"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="lastName">
              <div class="left">姓氏</div>
              <el-input
                ref="lastName"
                v-model="loginForm2.lastName"
                placeholder="请输入您的姓氏"
                name="lastName"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="companyName">
              <div class="left">公司名称</div>
              <el-input
                ref="companyName"
                v-model="loginForm2.companyName"
                placeholder="请输入公司名称"
                name="companyName"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="monthlyInternational">
              <div class="left">以下哪一项最能描述您？</div>
              <el-select
                ref="selectref"
                v-model="loginForm2.monthlyInternational"
                placeholder="首次托运人"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in monthlyInternationalOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <button
            class="by-button--primary craetAccount"
            @click.stop="SignUp()"
          >
            提交
          </button>
        </div>
      </template>
      <template v-slot:footer>
        <div class="footer-first">
          注册即表示我接受
          <a :href="sysConfig.registerTermsUrl"
            target="_blank"
            style="text-decoration: none"
          ><span>条款和条件</span></a>
        </div>
        <div class="footer-two">
          我同意接收货运相关更新、行业见解和营销通讯。我知道我可以随时选择退出这些。
        </div>
        <div v-if="isShow" class="footer-tree">
          已有账户？<span @click="toLogin"> 去登录</span>
        </div>
      </template>
    </global-login-dialog>
  </div>
</template>

<script>
import { RegisterCheck, Register } from '@/api/user.js'
import { GetSysConfig } from '@/api/base.js'
import { getConfig, setConfig } from '@/utils/auth.js'
import { message } from '@/utils/message'
import { setCookie } from '@/utils/cookiejs'
import GlobalLoginDialog from '@/components/Dialog/Dialog.vue'
import md5 from 'js-md5'
export default {
  name: 'StartedDialog',
  components: {
    // 组件的引用
    GlobalLoginDialog
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      loginForm1: { email: '', password: '' },
      loginRules1: {
        email: [
          { required: true, trigger: 'blur', message: '请输入邮箱' },
          { pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '请输入密码' },
          { pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,}$/, message: '不少于8个字符，使用大小字母、数字和符号四种组合', trigger: 'blur' }
        ]
      },
      loginForm2: { firstName: '', lastName: '', companyName: '', monthlyInternational: '' },
      loginRules2: {
        firstName: [{ required: true, trigger: 'blur', message: '请输入名称' }],
        lastName: [{ required: true, trigger: 'blur', message: '请输入姓' }],
        companyName: [
          { required: true, trigger: 'blur', message: '请输入公司名名称' },
          { min: 3, message: '公司名称不小于三个字符', trigger: 'blur' }
        ],
        monthlyInternational: [{ required: true, trigger: 'blur', message: '请选择' }]
      },
      isShow: true,
      monthlyInternationalOptions: [
        { value: '首次托运人', label: '首次托运人' },
        { value: '不超过10单', label: '不超过10单' },
        { value: '10-49', label: '10-49' },
        { value: '50+', label: '50+' },
        { value: '其它', label: '其它' }
      ],
      sysConfig: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.sysConfig = getConfig() || {}
    this.initSysConfig()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    initSysConfig() {
      GetSysConfig().then(res => {
	  if (res.code === 200) {
          setConfig(res.data)
          this.sysConfig = res.data
	  }
      })
    },
    // 方法
    closeDialog() {
      this.$store.commit('user/STARTED_VISIBLE', false)
    },
    createAccount() {
      this.$refs.loginForm1.validate((valid) => {
        if (valid) {
          RegisterCheck(this.loginForm1.email).then((res) => {
            if (res.code === 200) {
              if (res.data === true) {
                this.isShow = false
              } else {
                setCookie('token', res.data)
                this.$emit('success')
                this.$store.commit('user/STARTED_VISIBLE', false)
                setTimeout(() => {
                  this.$store.commit('user/SUCCESS_VISIBLE', true)
                }, 0)
              }
            } else {
              message({
                message: res.message,
                type: 'error'
              })
            }
          })
        }
      })
    },
    SignUp() {
      this.$refs.loginForm2.validate((valid) => {
        if (valid) {
          var data = {
            email: this.loginForm1.email,
            password: md5(this.loginForm1.password),
            firstName: this.loginForm2.firstName,
            lastName: this.loginForm2.lastName,
            companyName: this.loginForm2.companyName,
            monthlyInternational: this.loginForm2.monthlyInternational
          }
          Register(data).then((res) => {
            if (res.code === 200) {
              setCookie('token', res.data)
              this.$emit('success')
              this.$store.commit('user/STARTED_VISIBLE', false)
              setTimeout(() => {
                this.$store.commit('user/SUCCESS_VISIBLE', true)
              }, 0)
            } else {
              message({
                message: res.message,
                type: 'error'
              })
            }
          })
        }
      })
    },
    toLogin() {
      this.$store.commit('user/DIALOG_VISIBLE', true)
      this.$store.commit('user/STARTED_VISIBLE', false)
    }
  }
}
</script>
<style scoped lang="scss">
// 选中动态颜色
$atv-colorBR: #0046b9;
$stroke-color-index2: #f0f0f0;

.footer-font {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  margin-bottom: 8px;
}

.startedDialog {
  .left {
    text-align: left;
  }

  .craetAccount {
    width: 336px;
    height: 40px;
    margin-top: 8px;
  }

  .footer-first,
  .footer-tree {
    @extend .footer-font;

    span {
      color: #027ffc;
      cursor: pointer;
    }
  }

  .footer-two {
    @extend .footer-font;
  }

  ::v-deep .dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.2);
  }

  ::v-deep .dialog {
    //display: flex;
    width: 384px;
    min-height: 482px;
    background: #ffffff;
    border-radius: 16px;
    padding: 0;
    box-shadow: none;
    //top: 50%;
    //margin-top: -188px;
  }

  ::v-deep .dialog_all {
    box-sizing: border-box;
    width: 344px;
  }

  ::v-deep .dialog__header {
    width: 384px;
    height: 64px;
    background: linear-gradient(
      180deg,
      rgba(51, 112, 255, 0.06) 0%,
      rgba(51, 112, 255, 0.12) 100%
    );
    border-radius: 16px 16px 0px 0px;
    padding: 16px 24px;

    .title-first {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
    }

    .title-two {
      font-size: 14px;
      font-family: D, D;
      font-weight: normal;
      color: #777777;
      text-align: center;
      margin-top: 8px;
    }
  }

  ::v-deep .dialog__title {
    line-height: 56px;
  }

  ::v-deep .dialog__body {
    padding: 16px 24px 0;

    .el-form-item {
      margin-bottom: 12px !important;
      width: 336px;

      .el-select {
        display: block;
      }
    }
  }

  ::v-deep .dialog__footer {
    width: 341px;
    padding: 16px 24px;
    text-align: left;
  }

  ::v-deep .dialog__header .dialog__headerbtn {
    position: relative;
    top: -32px;
    right: -164px;
  }
}
</style>
